export interface MediaOptions {
  id?: string
  type?: string
  src?: string
  thumbnailSrc?: string
  altText?: string
}

export interface Media {
  id: string
  type: string
  src: string
  thumbnailSrc: string
  altText: string
}

export const createMedia = (options: MediaOptions): Media => {
  return {
    id: '',
    type: 'image',
    src: '',
    thumbnailSrc: '',
    altText: '',
    ...options
  }
}
